import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={45}
    height={45}
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M43.5939 21.0938H25.7812C25.005 21.0938 24.375 20.4638 24.375 19.6875C24.375 18.9112 25.005 18.2812 25.7812 18.2812H43.5939C44.3701 18.2812 45.0001 18.9112 45.0001 19.6875C45.0001 20.4638 44.3701 21.0938 43.5939 21.0938Z"
      fill="#4682B4"
    />
    <path
      d="M36.5626 28.125C36.2025 28.125 35.8427 27.988 35.5687 27.7127C35.0194 27.163 35.0194 26.2724 35.5687 25.7231L41.6064 19.6858L35.5687 13.6481C35.0194 13.0988 35.0194 12.2082 35.5687 11.6589C36.1184 11.1092 37.009 11.1092 37.5583 11.6589L44.5895 18.6901C45.1388 19.2395 45.1388 20.13 44.5895 20.6793L37.5583 27.7106C37.2826 27.988 36.9228 28.125 36.5626 28.125Z"
      fill="#4682B4"
    />
    <path
      d="M15.0001 45C14.5988 45 14.218 44.9437 13.8376 44.8256L2.55363 41.0662C1.0183 40.5299 0 39.0993 0 37.5001V3.75011C0 1.68194 1.68194 0 3.75011 0C4.15112 0 4.53186 0.056305 4.91261 0.174408L16.1963 3.93379C17.7319 4.47006 18.7499 5.90069 18.7499 7.49989V41.2499C18.7499 43.3181 17.0683 45 15.0001 45ZM3.75011 2.8125C3.23444 2.8125 2.8125 3.23444 2.8125 3.75011V37.5001C2.8125 37.8994 3.08064 38.2705 3.4631 38.4037L14.6942 42.1463C14.7749 42.1724 14.88 42.1875 15.0001 42.1875C15.5158 42.1875 15.9374 41.7656 15.9374 41.2499V7.49989C15.9374 7.1006 15.6693 6.72947 15.2868 6.59626L4.05567 2.8537C3.97499 2.82761 3.86993 2.8125 3.75011 2.8125Z"
      fill="#4682B4"
    />
    <path
      d="M28.5935 15.0001C27.8173 15.0001 27.1873 14.3701 27.1873 13.5939V5.15636C27.1873 3.86444 26.1357 2.8125 24.8438 2.8125H3.75C2.97375 2.8125 2.34375 2.1825 2.34375 1.40625C2.34375 0.629997 2.97375 0 3.75 0H24.8438C27.6882 0 29.9998 2.31194 29.9998 5.15636V13.5939C29.9998 14.3701 29.3698 15.0001 28.5935 15.0001Z"
      fill="#4682B4"
    />
    <path
      d="M24.844 39.375H17.3438C16.5675 39.375 15.9375 38.745 15.9375 37.9687C15.9375 37.1925 16.5675 36.5625 17.3438 36.5625H24.844C26.1359 36.5625 27.1875 35.5106 27.1875 34.2186V25.7811C27.1875 25.0049 27.8175 24.3749 28.5938 24.3749C29.37 24.3749 30 25.0049 30 25.7811V34.2186C30 37.0631 27.6884 39.375 24.844 39.375Z"
      fill="#4682B4"
    />
  </svg>
);

export default SVGComponent;
